import React from "react";
import { HashRouter as Router } from "react-router-dom";

import clsx from "clsx";
import { makeStyles, createStyles } from "@material-ui/core/styles";

import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
//import Toolbar from "@material-ui/core/Toolbar";
//import Typography from "@material-ui/core/Typography";
import AppRoutes from "../router/AppRoutes";
import { isBrowser, isMobile } from "react-device-detect";
//import { Box } from "@material-ui/core";
import { SnackbarProvider } from "notistack";

const drawerWidth = 0;
//Estilos para el  componente
const useStyles = makeStyles((theme) => {
  return createStyles({
    root: {
      display: "flex",
    },
    title: {
      height: "100%",
      marginTop: 5,
      textAlign: "left",
      // marginLeft: 400,
    },
    appBar: {
      //  marginTop: 52,
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    // appBarLogo: {
    //   width: "100%",
    //   height: "52px",
    //   display: "flex",
    //   position: "fixed",
    // },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    hide: {
      display: "none",
    },

    drawerHeader: {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
      justifyContent: "flex-end",
    },
    content: {
      //  marginTop: 52,
      flexGrow: 1,
      padding: theme.spacing(0),
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: -drawerWidth,
    },
    contentShift: {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
    success: { backgroundColor: "#235B4E" },
  });
});

//Componente raiz de la aplicación
export default function App(props) {
  const classes = useStyles();
  const [open] = React.useState(isBrowser);

  return (
    <SnackbarProvider
      classes={{
        variantSuccess: classes.success,
        variantError: classes.error,
        variantWarning: classes.warning,
        variantInfo: classes.info,
      }}
      preventDuplicate
      maxSnack={3}
      autoHideDuration={3000}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
    >
      <Router>
        <div className={classes.root}>
          <CssBaseline />

          {/* <Box className={classes.appBarLogo}>
          <img
            alt="Logo"
            src="./imgs/logosgirpc.png"
            height={isMobile ? 40 : 52}
            style={{
              backgroundColor: "white",
              margin: "auto",
            }}
          ></img>
        </Box> */}

          <AppBar
            position="fixed"
            className={clsx(classes.appBar, {
              [classes.appBarShift]: open,
            })}
          >
            {/* <Toolbar>
            {isBrowser ? (
              <Box>
                <Box display={{ xs: "none", md: "block" }}>
                  <Typography
                    component={Box}
                    variant="h6"
                    className={classes.title}
                  >
                    Monitoreo de Fenómenos
                  </Typography>
                </Box>
              </Box>
            ) : (
              <Box style={{ width: "100%" }}>
                <Typography
                  variant="body2"
                  display="inline"
                  style={{ height: "100%" }}
                >
                  Monitoreo de Fenómenos
                </Typography>
              </Box>
            )}
          </Toolbar> */}
          </AppBar>
          {/* Componente para renderear el contenido de las rutas */}
          <main
            className={clsx(classes.content, {
              [classes.contentShift]: open,
            })}
          >
            {/* <div className={classes.drawerHeader} /> */}

            <AppRoutes></AppRoutes>
          </main>
        </div>
      </Router>
    </SnackbarProvider>
  );
}
